module.exports = __webpack_public_path__ + "static/media/watsapp-atend.bc653d9d.png";